/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface EmailAddressAvailableParams {
    emailAddress: string;
}

export function emailAddressAvailablePost(http: HttpClient, rootUrl: string, params: EmailAddressAvailableParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(rootUrl, emailAddressAvailablePost.PATH, 'post');
    if (params.emailAddress) {
        rb.query('emailAddress', params.emailAddress)
    }

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<string>;
        })
    );
}

emailAddressAvailablePost.PATH = '/api/v1/accounts/email-address-available';
